import { GetRecommendationsResponseBodyType } from "@intelligems/ig-types";
import { RecommendationAction } from "@src/components/recommendation/types";
import { useQuery } from "@tanstack/react-query";

import { wrapAnalyticsRequest } from "../analytics/utils";
import { analyticsApi } from "../api";
import { useGetOrg } from "../organizations/get-organization";
import { uiRecommendationKeys } from "../queryKeys";

export const mapRecContentActions = (
  actions: Array<{ type: string; text: string; destination: string }>,
  navigate: (path: string) => void
): RecommendationAction[] =>
  actions.map((a, i) => ({
    key: `rec-action-${i}`,
    label: a.text,
    onClick: () => {
      if (a.destination.startsWith("http")) {
        window.open(a.destination, "_blank", "noopener,noreferrer");
      } else {
        navigate(a.destination);
      }
    },
    destination: a.destination,
  }));

interface UseGetRecommendationsOptions {
  enabled?: boolean;
}

const getRecommendations =
  async (): Promise<GetRecommendationsResponseBodyType> => {
    try {
      const response = await wrapAnalyticsRequest(async () =>
        analyticsApi.get<GetRecommendationsResponseBodyType>(
          "/v2/analytics/recommendations"
        )
      );

      return response.data;
    } catch (error) {
      return { recommendation: null };
    }
  };

export const useGetRecommendations = ({
  enabled,
}: UseGetRecommendationsOptions) => {
  const org = useGetOrg();
  const orgId = org.data?.org?.id;

  return useQuery<GetRecommendationsResponseBodyType, Error>({
    queryKey: uiRecommendationKeys.one(orgId),
    queryFn: async () => getRecommendations(),
    enabled,
  });
};
